import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '../api/errors';

// A rejection is an answer, not an outage: retrying a 4xx cannot change it and only delays the message.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (attempt, error) => {
        if (error instanceof ApiError && error.status < 500) return false;
        return attempt < 2;
      },
      staleTime: 10_000,
      refetchOnWindowFocus: false,
    },
    mutations: { retry: false },
  },
});
